var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  label: "Type of Redirect",
                  name: "Type",
                  items: _vm.redirects,
                  "error-messages": _vm.errors.collect("Type")
                },
                model: {
                  value: _vm.model.type,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "type", $$v)
                  },
                  expression: "model.type"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-input-label", [_vm._v("Select Domain")]),
              _c("domain-select", {
                staticClass: "gg-input",
                attrs: {
                  "all-domains": "",
                  "no-label": "",
                  outlined: "",
                  dense: "",
                  remote_domain: _vm.model.domain
                },
                model: {
                  value: _vm.model.domain,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "domain", $$v)
                  },
                  expression: "model.domain"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-text-field", {
                attrs: {
                  label: "Folder",
                  outlined: "",
                  dense: "",
                  placeholder: "Enter a folder",
                  prefix: "/"
                },
                model: {
                  value: _vm.model.src,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "src", $$v)
                  },
                  expression: "model.src"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|url:require_protocol",
                    expression: "'required|url:require_protocol'"
                  }
                ],
                attrs: {
                  name: "Redirects to",
                  label: "Redirects to",
                  placeholder: "Enter a domain",
                  "error-messages": _vm.errors.collect("Redirects to")
                },
                model: {
                  value: _vm.model.redirect,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "redirect", $$v)
                  },
                  expression: "model.redirect"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-input-label", [_vm._v("www. Redirection:")]),
              _c(
                "v-radio-group",
                {
                  staticClass: "mt-0",
                  attrs: {
                    disabled: _vm.disabledRadios,
                    "hide-details": ""
                  },
                  model: {
                    value: _vm.model.redirect_www,
                    callback: function callback($$v) {
                      _vm.$set(_vm.model, "redirect_www", $$v)
                    },
                    expression: "model.redirect_www"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      color: "primary",
                      label: "Only redirect with www.",
                      value: "2"
                    }
                  }),
                  _c("v-radio", {
                    attrs: {
                      color: "primary",
                      label: "Redirect with or without www.",
                      value: "0"
                    }
                  }),
                  _c("v-radio", {
                    attrs: {
                      color: "primary",
                      label: "Do Not Redirect www.",
                      value: "1"
                    }
                  })
                ],
                1
              ),
              _c("v-checkbox", {
                attrs: {
                  label: "Wild Card Redirect",
                  color: "primary",
                  "hide-details": "",
                  "true-value": "1",
                  "false-value": "0"
                },
                model: {
                  value: _vm.model.redirect_wildcard,
                  callback: function callback($$v) {
                    _vm.$set(_vm.model, "redirect_wildcard", $$v)
                  },
                  expression: "model.redirect_wildcard"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "ml-0 mt-3",
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.addRedirect
                  }
                },
                [_vm._v(" Add Redirect ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }